// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"pq-z","outfitFeedbackSection":"qq-z"};